import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Icon, Table, Card, Popup, Dropdown, Loader} from 'semantic-ui-react';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import {printDateFormat} from '../../../common/constants/datesFormat';
import {printBinningLabels} from '../../../common/util/print';
import TablePaginator from '../../../common/components/tablePaginator';

class LabelsReprinterTable extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onPageClick(value) {
    this.props.changeLabelsListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeLabelsListPageSize(data.value);
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderLabels() {
    const {labels} = this.props;

    if (!labels.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={10}>No hay etiquetas disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return labels.map((element, index) => {
      const dateFormatted = element.printingDate ? moment(element.printingDate).format(printDateFormat) : '';
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{dateFormatted.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{element.box}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partLocation}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partQuantity || 0}</Table.Cell>
          <Table.Cell textAlign='center'>{element.labelType}</Table.Cell>
          <Table.Cell textAlign='center'>{element.agency}</Table.Cell>
          <Table.Cell textAlign='center'>{element.user.toUpperCase() || '' }</Table.Cell>
          <Table.Cell textAlign='center'>
            <Popup
              trigger={
                <Icon name='print' color='blue' size='large' onClick={() => printBinningLabels([element])} />
              }
              content='Imprimir'
              position='top center'
              inverted
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrLabels() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderLabels();
  }

  renderLabelsTable() {
    return (
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Caja No.</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Ubicación</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Conteo Físico</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Tipo Etiqueta</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
    
        <Table.Body>
          {this.renderLoaderOrLabels()}
        </Table.Body>

        {this.renderPagination()}
      </Table>
    );
  }

  render() {
    return (
      <Card fluid raised className='primary-content'>
        {this.renderLabelsTable()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.labelsReprint.loadingLabelsByInvoice,
    'labels': state.labelsReprint.labelsListByPage,
    'pageNumber': state.labelsReprint.pageNumber,
    'pageSize': state.labelsReprint.pageSize,
    'totalItems': state.labelsReprint.labelsList.length,
  };
};

const {
  changeLabelsListPage,
  changeLabelsListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  changeLabelsListPage,
  changeLabelsListPageSize,
})(LabelsReprinterTable);
